import { Personas } from '@/enums/persona';
import { Service } from 'vue-di-container';

@Service()
export default class SharedDataService {
  public get Personas() {
    return Personas;
  }
}
